// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixField } from './PFixField';
export class PFixDateField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = null;
    }
    ReadValue(buffer) {
        this.Value = buffer.ReadDate();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        if (!this.Value) {
            this.Value = new Date();
        }
        buffer.WriteDate(this.Value);
    }
}
